var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlternova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1079,
    height: 132,
    viewBox: "0 0 1079 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_687_488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.09 0.543701H108.452H88.7604H85.3941L8.05762 115.239H47.7536L102.27 34.4017H108.452V69.636H85.5281L63.4831 103.494H108.452V115.239H141.43V0.543701H140.03H125.09ZM382.898 0.543701H349.965H349.92V34.4017V38.9436V115.239H349.965H382.883H382.898H471.272V81.3808H382.898V74.8203H446.442V40.9623H382.898V34.4017H421.224H471.272V0.543701H421.224H382.898ZM603.75 74.8203V72.4652V40.9623V34.4017V0.543701H570.787H481.445V34.4017H570.787V40.9623H514.379H509.016H481.4V115.239H514.379V74.8203H603.75ZM619.942 0.543701H646.456H659.638L736.989 115.239H697.278L646.456 39.8765V115.239H613.492V0.543701H619.942ZM703.579 13.4661H736.557V102.317L703.579 53.7776V13.4661ZM779.53 40.9623H746.552V115.239H746.611H779.53H867.919V81.3808H779.53V40.9623ZM746.611 34.4017V0.543701H834.94H867.919V34.4017V74.8203H834.94V34.4017H746.611ZM911.219 75.906L962.042 0.543701H1001.74L924.402 115.239H911.219H884.691H878.241V0.543701H911.219V75.906ZM565.499 115.239L542.68 81.3809H582.376L605.21 115.239H565.499ZM1054.08 0.543701H1069.02H1070.41V115.239H1037.44V103.494H992.459L1014.5 69.636H1037.44V34.4017H1031.25L976.729 115.239H937.033L1014.37 0.543701H1017.75H1037.44H1054.08ZM262.648 0.543701H218.483V34.4017H262.648V115.239H295.626V34.4017H339.791V0.543701H295.626H262.648ZM151.708 0.543701H184.671V81.3808H252.326V115.239H184.671H151.708V81.3808V0.543701Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_687_488",
    x: 0.0576172,
    y: 0.543701,
    width: 1078.35,
    height: 130.695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_488",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternova);
export default __webpack_public_path__ + "static/media/alternova.1092fb38e7489b99864005f71038dcb5.svg";
export { ForwardRef as ReactComponent };